import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { QaLocatorsModule } from '@metromarkets/sdk';
import {
  MmAlertModule,
  MmButtonModule,
  MmCheckboxModule,
  MmRadioModule,
  MmFormFieldModule,
  MmIconModule,
} from '@metromarkets/components';

import { ErrorMessagePipe } from './pipes/error-message.pipe';
import { AdvancedFormComponent } from './components/advanced-form/advanced-form.component';
import { MetroCardFieldComponent } from './components/metro-card-field/metro-card-field.component';
import { PasswordFieldComponent } from './components/password-field/password-field.component';
import { AutocompleteFieldComponent } from './components/autocomplete/autocomplete.component';
import { PasswordStrengthVisualizerComponent } from './components/password-strength-visualizer/password-strength-visualizer.component';
import { TooltipModule } from '../tooltip/tooltip.module';
import { NoSpacesModule } from '~shared/directives/no-spaces/no-spaces.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
  declarations: [
    AdvancedFormComponent,
    MetroCardFieldComponent,
    PasswordFieldComponent,
    PasswordStrengthVisualizerComponent,
    AutocompleteFieldComponent,
    ErrorMessagePipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NoSpacesModule,
    TranslateModule,
    DigitOnlyModule,
    QaLocatorsModule,
    MmAlertModule,
    TooltipModule,
    MmButtonModule,
    MmCheckboxModule,
    MmRadioModule,
    MmFormFieldModule,
    MmIconModule,
    MatAutocompleteModule,
  ],
  exports: [AdvancedFormComponent, ErrorMessagePipe],
})
export class AdvancedFormModule {}
